'use strict';

var arrayWithHoles$1 = require('./arrayWithHoles.js');
var iterableToArrayLimit$1 = require('./iterableToArrayLimit.js');
var nonIterableRest$1 = require('./nonIterableRest.js');

var arrayWithHoles = arrayWithHoles$1;

var iterableToArrayLimit = iterableToArrayLimit$1;

var nonIterableRest = nonIterableRest$1;

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || nonIterableRest();
}

var slicedToArray = _slicedToArray;

module.exports = slicedToArray;
